module.exports = __webpack_public_path__ + "static/ResDiary-5b734eae541bd6bfd8fa9d45efb3928a.svg";